export default __webpack_public_path__ + "static/panoramic-31cc12f83eb61b5d8feea7236fc5d105.jpg";